<template>
  <iframe :src="hrefUrl"></iframe>
</template>

<script>
export default {
  data() {
    return {};
  },
  method() {},
  props: {
    hrefUrl: {
      type: String,
      default: ""
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/designer.vue